<script lang="ts">
  import clsx from 'clsx';
  import {
    getColorContextValue,
    getColorContext,
    initializeColorContext,
    setContainerContextMaxPixelWidth,
  } from '@athena-lib/container-context.svelte';
  import { getImageContext } from '@athena-lib/Image/context';
  import {
    getPageSectionWidth,
    getPageSectionXPadding,
    getPageWidthClass,
    type InnerPageSectionProps,
  } from './types';
  import { getBackgroundClass, getBackgroundImageCssVariable } from './utils';

  const {
    children,
    width = 'large',
    innerClass,
    backgroundColor,
    backgroundMediaUrl,
    fullWidthBackgroundMedia,
    fullWidthBackgroundColor = false,
    class: className,
    xSpace,
  }: InnerPageSectionProps = $props();
  setContainerContextMaxPixelWidth(getPageSectionWidth(width));

  // we should initialize based on parent context
  const parentColorContext = getColorContext();
  const colorContext = initializeColorContext(
    getColorContextValue(backgroundColor ?? parentColorContext.value),
  );
  $effect.pre(() => {
    colorContext.value = getColorContextValue(backgroundColor ?? parentColorContext.value);
  });

  const backgroundClass = $derived(
    getBackgroundClass(backgroundColor, backgroundMediaUrl, fullWidthBackgroundColor, false),
  );
  const imageContext = getImageContext();

  const backgroundImageCssVariable = $derived(
    getBackgroundImageCssVariable(backgroundMediaUrl, imageContext),
  );
</script>

<div
  style={fullWidthBackgroundMedia ? backgroundImageCssVariable : undefined}
  class={clsx(
    'w-full',
    backgroundImageCssVariable && 'bg-[image:var(--background-image-url)]',
    fullWidthBackgroundColor && backgroundClass,
    className,
    xSpace !== 'none' && getPageSectionXPadding(width),
  )}
>
  <div
    class={clsx(
      innerClass,
      backgroundClass,
      backgroundImageCssVariable && 'bg-[image:var(--background-image-url)]',
      'mx-auto h-full',
      width === 'full' ? 'w-full' : getPageWidthClass(width),
    )}
    style={!fullWidthBackgroundMedia ? backgroundImageCssVariable : undefined}
  >
    {@render children()}
  </div>
</div>
